<template>
  <div>
    <div class="flex flex-col justify-between">
      <div class="flex flex-col items-center">
        <div class="flex mb-1 font-semibold text-custom-dark">
          {{ $t('frontend_groovevideo_videos_youtube_title') }}
        </div>
        <text-input
          v-model="youtubeUrl"
          :validator="$v.youtubeUrl"
          value="youtubeUrl"
          class="mx-4 text-deep-dark video-url-input"
          :attribute="$t('frontend_groovevideo_videos_youtube_title')"
          :placeholder="$t('frontend_groovevideo_videos_eg_youtube')"
        />
      </div>
      <div v-if="currentUserAllowed" class="flex flex-col items-center">
        <div class="text-center mt-5 font-bold text-deep-dark">
          {{ $t('frontend_groovevideo_videos_fileupload_or') }}
        </div>
        <div class="flex my-3 font-semibold text-custom-dark">
          {{ $t('frontend_groovevideo_videos_add_from_youtube') }}
        </div>

        <div
          class="
            flex flex-row
            justify-center
            items-center
            border-grey-300 border border-solid
            cursor-pointer
            youtubeBtnBox
            text-custom-dark
            py-2
          "
          @click="goToSettings"
          v-if="accounts.length === 0"
        >
          {{ $t('frontend_groovevideo_connect_with_youtube') }}
          <youtube-icon class="ml-2" />
        </div>

        <div v-else class="flex">
          <gd-button
            size="medium"
            class="
              mr-4
              px-4
              mb-2
              font-semibold
              upload-youtube-button
              border-grey-300
            "
            @click="openUploadModal"
          >
            {{
              $t(
                'frontend_groovevideo_upload_to_youtube'
              )
            }}
            <youtube-icon class="ml-2" />
          </gd-button>

          <!-- <gd-button
            class="w-32 text-grey-700 border-grey-300"
            :disabled="true"
            >{{
              $t('frontend_groovevideo_select_video_from_youtube')
            }}</gd-button
          > -->
        </div>

        <gd-modal
          ref="uploadModal"
          name="uploadModal"
          :title="$t('frontend_groovevideo_publish_to_youtube')"
          bgType="black"
          @closed="resetUploadModal"
        >
          <div class="flex flex-col">
            <div class="flex pt-5 pb-4 px-8">
              <k-progress
                class="w-full youtube-upload-progress"
                :percent="progress"
                color="#27AE60"
                bg-color="#DDDDEB"
                :line-height="10"
                :show-text="true"
              >
              </k-progress>
            </div>

            <div>
              <div class="mb-6">
                <step1
                  ref="step1"
                  :videoModel="video"
                  :uploadModel="uploadModel"
                  :showDelete="currentTab === 'step1'"
                  :validateForm="validateForm"
                  :closeModal="closeUploadModal"
                  @uploadProgress="uploadProgress"
                  @updateDisplayUploadbox="updateDisplayUploadbox"
                  @showLoader="showLoader"
                  @hideLoader="hideLoader"
                ></step1>
              </div>
              <div class="text-left" v-if="currentTab === 'step2'">
                <step2
                  ref="step2"
                  :settings="accounts"
                  :model="uploadModel"
                ></step2>
              </div>
              <div class="text-left" v-if="currentTab === 'step3'">
                <step3 ref="step3" :model="uploadModel" :videoModel="model"></step3>
              </div>
              <div class="text-left" v-if="currentTab === 'step4'">
                <step4 ref="step4" :model="uploadModel"></step4>
              </div>
            </div>

            <div class="flex justify-center my-6">
              <gd-button
                v-if="currentTab === 'step1'"
                size="medium"
                class="w-48 mr-3 border-grey-300"
                @click="closeUploadModal"
              >
                {{ $t('frontend_cancel') }}
              </gd-button>
              <gd-button
                size="medium"
                v-else
                class="w-48 mr-3 border-grey-300"
                @click="changeTab('back')"
              >
                {{ $t('frontend_back') }}
              </gd-button>
              <gd-button
                v-if="currentTab !== 'step4'"
                primary
                size="medium"
                class="w-48"
                @click="changeTab('next')"
              >
                {{
                  currentTab == 'step1'
                    ? $t('frontend_groovevideo_upload_video_continue_btn')
                    : $t('frontend_next')
                }}
              </gd-button>
              <gd-button
                v-if="currentTab === 'step4'"
                primary
                size="medium"
                class="w-48 px-6"
                @click="publishVideo"
              >
                {{ $t('frontend_groovevideo_publish_video_now') }}
              </gd-button>
            </div>
          </div>
        </gd-modal>
      </div>
      <div class="flex justify-center mt-6">
        <gd-button v-if="model.video_source" class="mr-4" @click="sendBack">
          {{ $t('frontend_cancel') }}
        </gd-button>
        <gd-button primary @click="youtubeVideoLink">
          {{ $t('frontend_save') }}
        </gd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, url } from 'vuelidate/lib/validators';
import KProgress from 'k-progress';
import step1 from './step1';
import step2 from './step2';
import step3 from './step3';
import step4 from './step4';
import SourceType from '@/models/SourceType.js';
import Video from '@/models/Video';
import youtubeIcon from '@/assets/images/icons/YouTube.svg';

export default {
  props: {
    model: {
      required,
    },
    videoDetails: {},
    url: {
      default() {
        return '';
      },
    },
    accounts: {
      default() {
        return [];
      },
    },
    validateForm: {},
  },
  data() {
    return {
      youtubeUrl: '',
      availableApis: [],
      uploadModel: {
        selectedFile: null,
        fileLink: '',
        youtubeApiId: null,
        title: '',
        description: '',
        category: 22,
        tags: [],
        privacy: 'public',
      },
      video: null,
      currentTab: 'step1',
    };
  },
  components: {
    KProgress,
    step1,
    step2,
    step3,
    step4,
    youtubeIcon,
  },
  computed: {
    currentUserAllowed() {
      // Check if current user is allowed for testing new features
      const allowedUsers = [
        '5f0d5d4a6ca1bd0016c5142f',
        // '9d280130-6f1d-429a-8231-b7d77de8c3c4',
      ];

      return allowedUsers.includes(this.$store.state.user.id);
    },
    progress() {
      switch (this.currentTab) {
        case 'step1':
          return 0;
        case 'step2':
          return 30;
        case 'step3':
          return 60;
        case 'step4':
          return 90;
        default:
          return 0;
      }
    },
    steps() {
      return ['step1', 'step2', 'step3', 'step4'];
    },
  },
  mounted() {
    this.video = this.model;
    if (this.videoDetails) {
      this.video = this.videoDetails;
      if (this.videoDetails.video_source && !this.videoDetails.is_uploading) {
        this.youtubeUrl = this.videoDetails.video_source;
      }
    }
  },
  async created() {
    this.youtubeUrl = this.url;
    this.availableApis = this.accounts.filter((e) => {
      return e.access_token;
    });
    this.uploadModel.title = this.model.name;
    this.uploadModel.youtubeApiId = this.availableApis.length
      ? this.availableApis[0].id
      : null;
  },
  watch: {
    'model.name': function (value) {
      this.uploadModel.title = value;
    }
  },
  validations: {
    youtubeUrl: {
      required,
      url,
    },
  },
  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    resetUploadModal() {
      this.$v.$reset();
      this.currentTab = 'step1';
      this.uploadModel = {
        selectedFile: null,
        fileLink: '',
        youtubeApiId: this.availableApis.length
          ? this.availableApis[0].id
          : null,
        title: this.model.name,
        description: '',
        category: 22,
        tags: [],
        privacy: 'public',
      };
    },

    sendBack() {
      this.$router.push({
        name: 'AddNewVideo',
        params: { id: this.$route.params.id },
      });
    },
    goToSettings() {
      this.$router.push({
        name: 'settings',
        hash: '#youtube',
      });
    },

    changeTab(navigation) {
      const currentlySelectedTabIndex = this.steps.indexOf(this.currentTab);
      const validationFlag = this.$refs[this.currentTab].validate();
      if (validationFlag) {
        const nextIndex =
          navigation === 'next'
            ? currentlySelectedTabIndex + 1
            : currentlySelectedTabIndex - 1;
        this.currentTab = this.steps[nextIndex];
      }
    },

    async createVideo(publish) {
      // Create Video
      const video = new Video({
        name: this.video.name,
        category: this.video.category_id,
        youtubeUpload: publish,
      });
      this.video = (await video.save()).data;
    },

    async publishVideo() {
      const isValid = this.validateForm();
      if (isValid) {
        // Creating video
        await this.youtubeVideoLink(true);

        this.uploadModel.video_id = this.video.id;
        if (this.video.id) {
          this.hideLoader();
          this.$refs.step1.startUpload();
        }
      }
    },

    openUploadModal() {
      // import google api
      if (!document.getElementById('googleApis')) {
        // was already loaded
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.setAttribute('onload', "console.log('loaded')");
        scriptTag.id = 'googleApis';
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
      }

      this.$root.$emit('modal-open', 'uploadModal');
    },

    closeUploadModal() {
      this.$root.$emit('modal-close', 'uploadModal');
    },

    uploadProgress(file, progress, bytesSent) {
      this.$emit('uploadProgress', file, progress, bytesSent, true);
    },
    updateDisplayUploadbox(value) {
      this.$emit('updateDisplayUploadbox', value);
    },

    async youtubeVideoLink(publish = false) {
      this.$v.youtubeUrl.$touch();
      if (!this.$v.youtubeUrl.$invalid || publish) {
        this.showLoader();

        // Creating video
        if (!this.video.id) {
          await this.createVideo(true);
        }
        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.video.id;
        this.video_source_type.type = 2;
        this.video_source_type.source = this.youtubeUrl;
        this.video_source_type.name = this.video.name;
        this.video_source_type.category = this.video.category_id;
        this.video_source_type.youtubeApiId = publish
          ? this.uploadModel.youtubeApiId
          : undefined;

        this.video_source_type.save().then((res) => {
          if (res.status == 'success' && !publish) {
            this.$router.push({
              name: 'AddNewVideo',
              params: { id: this.video.id, mode: 'youtube' },
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.youtubeBtnBox {
  padding-left: 30px;
  padding-right: 30px;
  height: 40px;
  border-radius: 6px;
}
.youtube-upload-progress {
  .k-progress-text {
    color: #191d3a;
    margin-left: 16px;
  }
  &.k-progress {
    margin-right: 0px;
  }
  .k-progress-outer {
    margin-right: -40px;
  }
}
</style>

<style scoped>
.video-url-input {
  max-width: 500px;
}
.upload-youtube-button {
  color: #191d3a;
}
</style>
